module.exports = __webpack_public_path__ + "img/26.c58d0920.png";